import * as React from 'react';
import { createElement } from 'react';
import formatObj from './format';
export default class Time extends React.PureComponent {
    props;
    state;
    setState;
    constructor(props) {
        super(props);
        this.state = {
            time: formatObj(props.format),
            Timer: null
        };
    }
    timeChange = () => {
        this.setState({
            Timer: setInterval(() => {
                this.setState({
                    time: formatObj(this.props.format)
                });
            }, 1000)
        });
    };
    componentDidMount() {
        this.timeChange();
    }
    componentWillUnmount() {
        clearInterval(this.state.Timer);
    }
    componentWillReceiveProps(nextProps) {
        this.setState({
            time: formatObj(nextProps.format)
        });
    }
    render() {
        return (createElement("span", { className: "Time-content", style: { display: 'inline-block', ...this.props.style } }, this.state.time));
    }
}
;
